module.exports = __webpack_public_path__ + "static/media/triclorotableta.9167a8cd.pdf";